import { PurchaseEvent } from '@/usecases/event-bus-for-third-party/event'

export function sendToGA(event: PurchaseEvent): void {
  const payload = convertToGAFormat(event)

  payload.forEach((p) => {
    window.dataLayer.push(p)
  })
}

export function convertToGAFormat(event: PurchaseEvent): PurchaseToGA[] {
  const { orderResultSuccessList } = event

  return orderResultSuccessList.map((result) => {
    const subtotal = result.commerceSalesOrder.subtotalPrice
    const tax = result.commerceSalesOrder.tax
    const products = result.order.cartItems.map(cartItem => ({
      sku: cartItem.skuId,
      name: cartItem.name,
      price: cartItem.unitPrice,
      quantity: cartItem.unitCount,
    }))

    return {
      event: 'e-commerce',
      transactionId: result.commerceSalesOrder.compressedShortId,
      transactionTotal: subtotal,
      transactionTax: tax,
      transactionProducts: products,
      email: event.user.email,
      phone: event.user.tel,
    }
  })
}

interface PurchaseToGA {
  event: 'e-commerce'
  transactionId: string
  transactionTotal: number
  transactionTax: number
  transactionProducts: Array<{
    sku: string
    name: string
    price: number
    quantity: number
  }>
}
